<template>
  <v-container grid-list-lg fill-height>
    <v-layout align-center justify-center fill-height column>
      <v-flex shrink>
        <div class="text-center text-h4">Subscription</div>
      </v-flex>

      <v-flex shrink>
        <div class="text-center mx-5">
          Your Subscription was cancel, Please create 917-529-7186
        </div>
      </v-flex>

      <!-- <v-flex class="mt-3" shrink>
        <div class="text-center mb-5">Enter New Subscription ID </div>
        <v-layout row wrap>
          <v-flex>
            <v-text-field solo v-model="subscription" label="Subscription"></v-text-field>
          </v-flex>
          <v-flex xs1>
            <v-btn color="success">Update</v-btn>
          </v-flex>
        </v-layout>
      </v-flex> -->

      <!-- <v-flex shrink class="mt-5">
        <v-btn color="primary" dark>
          <StartSubscription v-if="location" :location="location" :customer="customer" buttonStyle="button"></StartSubscription>
        </v-btn>
      </v-flex> -->

      <v-flex shrink class="mt-2">
        <v-btn color="primary" @click="goBackHome" >Back Home</v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import StartSubscription from "@/modules/Location/components/StartSubscription.vue";

export default {
  name: "no-subscription",
  data() {
    return {
      subscription: null,
      location: null,
      customer: null,
    }
  },
  components: {
    StartSubscription,
  },
  // created() {
  //   console.log("created was call", this.$route.params);
  //   if (!this.$route.params || !this.$route.params.location) {
  //     return this.$router.push({ path: "/backoffice" });
  //   }
  //   this.customer = this.$route.params.customer
  //   this.location = this.$route.params.location
  //   // this.subscription = this.$route.params.subscription
  // },
  methods: {
    goBackHome() {
      this.$router.push({ path: '/' })
    }
  }
};
</script>

<style scoped></style>